(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["event-metaobject-table-archived"] && !Shopify.designMode) return;
  try {
    (() => {
    const initPagination = (root = document) => {
      root.querySelectorAll('[data-archived-events-pagination]').forEach((pagination) => {
        if (pagination.dataset.initialized === 'true') return;

        const table = pagination.closest('.archived-event-table');
        const list = table?.querySelector('[data-archived-events-list]');
        if (!list) return;

        const items = Array.from(list.querySelectorAll('[data-archived-event-item]'));
        const itemsPerPage = Number.parseInt(list.dataset.itemsPerPage, 10);
        const pageButtons = Array.from(pagination.querySelectorAll('[data-pagination-page]'));
        const previousButton = pagination.querySelector('[data-pagination-previous]');
        const nextButton = pagination.querySelector('[data-pagination-next]');
        const pagesCount = Math.ceil(items.length / itemsPerPage);
        let currentPage = 1;

        const setDisabled = (button, disabled) => {
          if (!button) return;
          button.disabled = disabled;
          button.setAttribute('aria-disabled', String(disabled));
          button.classList.toggle('pagination__link--disabled', disabled);
        };

        const showPage = (page, shouldScroll = true) => {
          currentPage = Math.min(Math.max(page, 1), pagesCount);
          const firstVisibleIndex = (currentPage - 1) * itemsPerPage;
          const lastVisibleIndex = firstVisibleIndex + itemsPerPage;

          items.forEach((item, index) => {
            item.hidden = index < firstVisibleIndex || index >= lastVisibleIndex;
          });

          pageButtons.forEach((button) => {
            const isCurrent = Number.parseInt(button.dataset.paginationPage, 10) === currentPage;
            button.classList.toggle('pagination__link--current', isCurrent);
            if (isCurrent) {
              button.setAttribute('aria-current', 'page');
            } else {
              button.removeAttribute('aria-current');
            }
          });

          setDisabled(previousButton, currentPage === 1);
          setDisabled(nextButton, currentPage === pagesCount);

          if (shouldScroll) {
            table.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        };

        pageButtons.forEach((button) => {
          button.addEventListener('click', () => {
            showPage(Number.parseInt(button.dataset.paginationPage, 10));
          });
        });
        previousButton?.addEventListener('click', () => showPage(currentPage - 1));
        nextButton?.addEventListener('click', () => showPage(currentPage + 1));

        pagination.dataset.initialized = 'true';
        showPage(1, false);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initPagination(), { once: true });
    } else {
      initPagination();
    }

    document.addEventListener('shopify:section:load', (event) => initPagination(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
